export default __webpack_public_path__ + "static/media/trustedby3.4eed6d2b.svg";